export function isHistoryWritable(): boolean {
  try {
    return typeof history !== 'undefined' && typeof history.replaceState === 'function';
  } catch {
    return false;
  }
}

export function safeReplaceQuery(params: { q?: string; tag?: string | null }) {
  if (!isHistoryWritable()) return;
  try {
    const sp = new URLSearchParams(window.location.search);
    if (params.q != null && params.q !== '') sp.set('q', params.q); else sp.delete('q');
    if (params.tag != null) sp.set('tag', params.tag); else sp.delete('tag');
    const qs = sp.toString();
    history.replaceState(null, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
  } catch {
    // ignora
  }
}

export function getShareBase(): string {
  try {
    if (typeof window !== 'undefined' && window.location.origin !== 'null') {
      return window.location.origin + window.location.pathname;
    }
  } catch {}
  return 'https://agenda.exemplo/';
}

export function resolveDataUrl(raw: string): string {
  // Converte URLs do Google Sheets de /pubhtml para /gviz se necessário
  if (raw.includes('/pubhtml')) {
    return raw.replace('/pubhtml', '/gviz/tq?tqx=out:json&gid=0');
  }
  return raw;
}